export default __webpack_public_path__ + "static/PLAYAVERSE_A-42582342e75a7dd5e1baf5343fc3456b.gif";